module.exports = __webpack_public_path__ + "img/LogoChefTete_Gris.732df556.png";